module.exports = __webpack_public_path__ + "img/shenzhen_tu.4da230dc.png";